export default __webpack_public_path__ + "static/media/userIcon.4254bba6.svg";